<template>
  <div>
    <Navbar />
    <main>
      <section class="brand-colors--green with-bg">
        <div class="container bg-guy">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 py-4 py-md-7">
              <h1 class="type-mono">We Are Hiring</h1>
            </div>
          </div>
        </div>
      </section>
      <section class="container py-5">
        <vue-markdown class="job-description">
        <!-- eslint-disable -->
# Technical Product Owner ・ API Integrations

**Location:** Espoo, Finland

**Type:** Hybrid

## Job description

As part of our engineering team, you will oversee implementation of Open Banking API integrations at scale. Already now we provide our clients connections to over 2500 banks and similar financial institutions (Account Servicing Payment Service Providers, ASPSPs). And you will play a key role in scaling one of Europe's most extensive Open Banking connectivity platforms.

**You will:**

* Own the implementation and lifecycle of API integrations with ASPSPs across the EEA;
* Work closely with engineers to build, improve, and migrate integrations;
* Close the occurring communication gaps between our engineers and ASPSPs;
* Collaborate with our compliance to escalate ASPSPs' API limitations and gaps;
* Translate technical support insights into engineering priorities.

Beyond communication, you will have to deeply understand integration-level capabilities and limitations, making sure the Enable Banking API provides an adequate level of abstraction. This role requires you to dig into integration metrics and understand specifics of Open Banking API for different markets and certain ASPSPs.

Alongside the lead engineer and the CTO you will drive the process around integrations to keep them at the highest reasonable quality, while maintaining expansion velocity and excellence of both internal and public documentation.

**We expect you to:**

* have a passion for delivering exceptional software products;
* have past experience as a Product Owner or in a similar role;
* possess strong technical knowledge, including a solid understanding of technology basics like web APIs, CI/CD, cloud platforms;
* be capable of independently analyzing metrics using SQL and digging into HTTP request/response logs;
* have experience leveraging AI and large language model (LLM) solutions in software engineering, e.g. internal or external documentation, tasks refinement, agentic automation;
* be able to effectively communicate both synchronously (in meetings) and asynchronous (via email and Slack);
* degree in computer science or similar.

**The following will be considered as an advantage:**

* previous experience working in a fintech environment, bringing an understanding of industry-specific technology and compliance perspectives;
* a background in software development.

## About Enable Banking

Enable Banking Oy provides to its clients state-of-the-art Open Banking aggregation technology, connecting to over 2500 banks and similar financial institutions in 30 countries. We develop high quality, secure software at a very fast pace. To be able to achieve this we rely on continuous integration and delivery, serverless cloud infrastructure, as well as automated testing and monitoring. We are ISO/IEC 27001 certified and are regulated by the Finnish supervisory authority (Finanssivalvonta).

Our customers are forerunners of Open Banking ranging from accounting software to neobanks core technology providers. Public references include Aura Cloud, Bolageriet, Isolta, Kreditz, Qred Bank and Zervant. We are a venture-funded, fast growing fintech, operating from Espoo, Vilnius, and Stockholm.

## Got interested? Apply now → [hr@enablebanking.com](mailto:hr@enablebanking.com)
        </vue-markdown>
      </section>
    </main>
    <AsideFooter />
  </div>
</template>

<script>
import VueMarkdown from '@adapttive/vue-markdown'
import AsideFooter from '../components/AsideFooter.vue'
import Navbar from '../components/Navbar.vue'
import metadata from '../mixins/metadata.js'

export default {
  name: 'careers-technical-product-owner',
  mixins: [metadata],
  components: {
    AsideFooter,
    Navbar,
    VueMarkdown
  }
}
</script>
<style lang="scss">
.job-description h2 {
  margin-top: 3rem;
  margin-bottom: 2rem;
}
.bg-guy {
  background-image: url('../assets/img/dude.jpg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right center;
}
</style>
